//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Query
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.ProfileQuery_ResponseAdapter
import com.wintermar.inspection.graphql.selections.ProfileQuerySelections
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.collections.List
import com.wintermar.inspection.graphql.type.Query as CompiledQuery

public class ProfileQuery() : Query<ProfileQuery.Data> {
  override fun equals(other: Any?): Boolean = other != null && other::class == this::class

  override fun hashCode(): Int = this::class.hashCode()

  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    // This operation doesn't have any variable
  }

  override fun adapter(): Adapter<Data> = ProfileQuery_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledQuery.type
  )
  .selections(selections = ProfileQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(ProfileQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val profile: Profile?,
  ) : Query.Data

  public data class Profile(
    public val id: Any,
    public val fullName: String,
    public val emailAddress: String,
    public val accesses: Accesses,
  )

  public data class Accesses(
    public val readOnly: List<String>,
    public val readWrite: List<String>,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "72da392f800a9304fe91a77a6598755ce92e6cc13c0084d523ef5ad1ac5c8d70"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * query profile {
     *   profile {
     *     id
     *     fullName
     *     emailAddress
     *     accesses {
     *       readOnly
     *       readWrite
     *     }
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "query profile { profile { id fullName emailAddress accesses { readOnly readWrite } } }"

    public const val OPERATION_NAME: String = "profile"
  }
}
